/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */

import { Fragment, useEffect, useRef, useState } from 'react'
import { FAQ_TITLE, FAQ_SUB, FAQ_GROUPS } from '../data/faq.jsx'

export function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false)
  const [pressed, setPressed] = useState(false)
  const justTouched = useRef(false)

  useEffect(() => {
    const clear = () => {
      if (justTouched.current) { justTouched.current = false; return }
      setPressed(false)
    }
    document.addEventListener('touchstart', clear, { passive: true })
    return () => document.removeEventListener('touchstart', clear)
  }, [])

  function handleTouch() {
    justTouched.current = true
    setPressed(true)
  }

  return (
    <div className={'seq-faq-item' + (open ? ' is-open' : '') + (pressed ? ' is-pressed' : '')}>
      <button type="button" className="seq-faq-q" aria-expanded={open ? 'true' : 'false'} onTouchStart={handleTouch} onClick={() => setOpen(!open)}>
        <span>{q}</span>
        <i className="seq-faq-ic" aria-hidden="true"></i>
      </button>
      <div className="seq-faq-a">
        <div className="seq-faq-in">{a}</div>
      </div>
    </div>
  )
}

export default function Faq() {
  return (
    <section id="faq" className="seq-faq" aria-label="سوالات متداول" dir="rtl">
      <h2 className="tm-title">{FAQ_TITLE}</h2>
      <p className="seq-faq-sub">{FAQ_SUB}</p>
      {FAQ_GROUPS.map((g) => (
        <Fragment key={g.title}>
          <h3 className="seq-faq-group">{g.title}</h3>
          <div className="seq-faq-list">
            {g.items.map((it) => (
              <FaqItem key={it.q} q={it.q} a={it.a} />
            ))}
          </div>
        </Fragment>
      ))}
    </section>
  )
}
